<nz-modal
  nzWrapClassName="form-modal"
  [(nzVisible)]="isVisibleModal && userType"
  [nzTitle]="modalTitle"
  [nzCentered]="true"
  [nzClassName]="'modal-m-t-30 tw-mb-7'"
  [nzContent]="modalContent"
  [nzFooter]="modalFooter"
  [nzMaskStyle]="{'background': 'rgba(255, 255, 255, 0.69)'}"
  (nzOnCancel)="onCloseModal(false)">
  <ng-template #modalTitle>
    <div class="container-steps-modal" [@fadeInAnimation]>
      <h2 class="text-title-md-bold title-modal">Nueva cita</h2>
      <p class="text-info mt-xxs">Se agregará la cita al servicio activo</p>
    </div>
  </ng-template>

  <ng-template #modalContent>
    <div class="container-modal" [@fadeInAnimation]>
      <form #formAppointment="ngForm">
        <div>
          <div class="title-section-form" nz-col nzSpan="24">
            <p class="title text-subtitle-bold-upper">TIPO DE CITA</p>
            <div class="cards-container">
              <app-card-icon-text *ngFor="let type of consultationTypes; index as i" class="appointment-type appointment-type-{{i}}"
                (click)="onChangeConsultationType(type)" [value]="type" [active]="consultationTypeSelected === type.id"></app-card-icon-text>
            </div>
          </div>
          <div class="title-section-form" nz-col nzSpan="24" *ngIf="stepSection>= 2" [class.disabled-container]="stepSection > currentStepSection &&
            currentStepSection <2" @fadeInAnimation>
              <div nz-col nzXs="24">
                <p class="input-label-form">Motivo de la cita</p>
                <textarea class="appointment-goal" [nzAutosize]="{ minRows: 1, maxRows: 5 }" nz-input [required]="false"
                  [(ngModel)]="reasonForConsultation"
                  #ngReasonForConsultation="ngModel" placeholder="(Opcional)" name="ngReasonForConsultation"></textarea> <!-- Sal del campo para continuar (blur)="onBlurReasonForConsultation($event)" -->
                <app-message-field [field]="ngReasonForConsultation"></app-message-field>
              </div>

              <!-- OBJETIVOS CLINICOS -->
              <div class="title-section mt-lg mb-xs">
                <p class="text-subtitle-bold-upper">Agrega objetivos</p>
              </div>

              <nz-select
                class="select-objectives"
                nzMode="multiple"
                name="ngObjectives" #ngObjectives="ngModel"
                nzPlaceHolder="Objectivos de la cita"
                [(ngModel)]="patientClinicalObjectives">
                <nz-option
                  *ngFor="let goal of clinicalObjectives"
                  [nzLabel]="goal.text"
                  [nzValue]="goal._id">
                </nz-option>
              </nz-select>
              <p class="text-info-sm mt-sm mb-sm" *ngIf="clinicalObjectives.length === patientClinicalObjectives.length">
                <i nz-icon nzType="info-circle" nzTheme="outline"></i>
                Todos los objetivos clínicos han sido seleccionados
              </p>
              <p class="text-info-sm" *ngIf="clinicalObjectives.length === 0">
                <i nz-icon nzType="info-circle" nzTheme="outline"></i>
                No hay objetivos clínicos
              </p>
              <p class="text-info-sm mt-sm" *ngIf="patientClinicalObjectives.length === 0">
                <i nz-icon nzType="info-circle" nzTheme="outline"></i>
                No hay objetivos clínicos seleccionados
              </p>
            </div>
            <div class="title-section-form" nz-col nzSpan="24" *ngIf="stepSection>= 3" [class.disabled-container]="stepSection > currentStepSection
              && currentStepSection <3" @fadeInAnimation>
                <p class="title text-subtitle-bold-upper">PARTICIPANTES</p>
                <div class="assistants">
                  <!-- <div *ngIf="userType !== 'patient'" class="add-new-assistant" nz-popover nzPopoverTitle="" [nzPopoverContent]="'Agregar nuevo asistente'" (click)="openAddAssistentModal()"> -->
                  <div *ngIf="userType !== 'patient' && (!(patient$ | async) && assistants.length === 0)" class="modal-add-new-assistant
                    add-new-assistant" nz-popover=""
                    nzPopoverTitle="" [nzPopoverContent]="'Agregar nuevo participante'" (click)="openAddAssistentModal()">
                    <i nz-icon nzType="plus" nzTheme="outline"></i>
                  </div>
                  <app-card-assistant
                    active="true"
                    *ngIf="(patient$ | async)"
                    [name]="(patient$ | async)?.user?.name + ' ' + (patient$ | async)?.user?.lastname"
                    [birthday]="(patient$ | async)?.user?.birthday"
                    [imageProfile]="(patient$ | async)?.user?.profileImageURL"
                    [gender]="(patient$ | async)?.user?.gender"
                    [selectable]="false"></app-card-assistant>
                  <ng-container *ngIf="assistants.length> 0">
                    <app-card-assistant
                      *ngFor="let assistant of assistantsExtra"
                      [name]="assistant.fullName"
                      [gender]="assistant.gender"
                      [imageProfile]="assistant.profileImageURL"
                      [birthday]="assistant?.birthday"
                      [selectable]="true"
                      active="true"
                      [erasable]="true"
                      (delete)="onRemoveAssistant(assistant)"></app-card-assistant>
                  </ng-container>
                </div>
                <button
                  *ngIf="buttonSkipAssistants && userType !== 'patient' && (assistants.length> 0 || (patient$ | async)) && false"
                  class="btn-default"
                  (click)="onSkipAssistant(true)"
                  nz-button nzType="default">OMITIR PARTICIPANTES
                </button>
                <!-- Se añadió el botón "CAMBIAR ASISTENTE" para cambiar al asistente (cuando solo se puede 1 máximo) -->
                <button
                  *ngIf="userType !== 'patient' && (assistants.length> 0 && !(patient$ | async))"
                  class="btn-default"
                  (click)="openAddAssistentModal()"
                  nz-button nzType="default">
                  <i nz-icon nzType="block" nzTheme="outline"></i>
                  CAMBIAR PARTICIPANTE
                </button>
              </div>
            </div>
            <!-- en caso de consulta presencial -->
            <div nz-row [nzGutter]="16" class="container-branch" *ngIf="consultationTypeSelected === 'presential' && stepSection>= 4"
              [class.disabled-container]="stepSection > currentStepSection && currentStepSection <4" @fadeInAnimation>
                <div nz-col nzXs="24" nzSm="10" nzMd="8" class="title-section-form select-branch">
                  <p class="title text-subtitle-bold-upper">SUCURSAL</p>
                  <ng-container *ngIf="(clinicBranches$ | async) as branches">
                    <nz-select nzShowSearch [required]="true" [(ngModel)]="branchOfficeId" name="ngBranchOffice" #ngBranchOffice="ngModel"
                      nzPlaceHolder="Selecciona la sucursal" (click)="onClickBranch($event, branches)"
                      (ngModelChange)="onChangeBranch($event, branches)">
                      <nz-option *ngFor="let clinicBranch of branches" [nzLabel]="clinicBranch.name" [nzValue]="clinicBranch._id"></nz-option>
                    </nz-select>
                  </ng-container>
                </div>
                <nz-divider class="address-vertical-divider" style="height: 120px; top: 10px;" nzType="vertical" *ngIf="branchOffice"></nz-divider>
                <div nz-col nzXs="24" nzSm="10" nzMd="8" class="title-section-form" *ngIf="branchOffice && branchOffice && branchOffice.address">
                  <p class="title text-subtitle-bold-upper">DIRECCIÓN</p>
                  <P class="text-info-regular">{{ branchOffice.address.street }}, {{ branchOffice.address.suburb }}</P>
                  <p class="text-info-regular">C.P. {{ branchOffice.address.cp }}</p>
                  <P class="text-info-regular">
                    <span *ngIf="branchOffice.address.city">{{ branchOffice.address.city }}, </span>
                    <span *ngIf="branchOffice.address.state">{{ branchOffice.address.state }}, </span>
                    <span *ngIf="branchOffice.address.country">{{ branchOffice.address.country }}</span>
                  </P>
                </div>
              </div>
              <!-- en caso de consulta en linea -->
              <div nz-row nzGutter="16" *ngIf="consultationTypeSelected === 'online' && userType === 'expert' && stepSection>= 4"
                [class.disabled-container]="stepSection > currentStepSection && currentStepSection <4" @fadeInAnimation>
                  <div class="title-section-form" nz-col nzSpan="24">
                    <p class="title text-subtitle-bold-upper">CITA EN LÍNEA</p>
                    <div nz-row nzGutter="16" class="online">
                      <div nz-col nzXs="24" nzMd="14" class="mb-sm">
                        <p class="input-label-form">URL de la sesión</p>
                        <nz-input-group [nzSuffix]="suffixIconEnter">
                          <input nz-input [required]="true" [(ngModel)]="urlSession.url" #ngUrlSession="ngModel" name="ngUrlSession"
                            (blur)="onBlurURLSession($event, urlSession, ngUrlSession)" (ngModelChange)="onValidateURL(urlSession.url, ngUrlSession)"
                            />
                        </nz-input-group>
                        <!--(keyup.enter)="onBlurURLSession($event, urlSession, ngUrlSession)"-->
                        <ng-template #suffixIconEnter>
                          <!--<i nz-icon nzType="enter" style="font-size: 20px;"></i>-->
                          <p class="text-info-sm ml-xxs">sal del campo para guardar</p>
                        </ng-template>
                        <!--
                <input nz-input [required]="true" [(ngModel)]="urlSession.url" #ngUrlSession="ngModel" name="ngUrlSession"  (blur)="onBlurURLSession($event, urlSession, ngUrlSession)" (ngModelChange)="onValidateURL(urlSession.url, ngUrlSession)"/> &lt;!&ndash; (blur)="onValidateURL(urlSession.url, ngUrlSession)" &ndash;&gt;
-->
                        <app-message-field [field]="ngUrlSession"></app-message-field>
                      </div>
                      <div nz-col nzXs="24" nzMd="10">
                        <p class="input-label-form">Notas de la sesión</p>
                        <textarea [placeholder]="'(Opcional)'" [nzAutosize]="{ minRows: 1, maxRows: 4 }" nz-input [required]="false"
                          [(ngModel)]="notesSession" #ngNotesSession="ngModel" name="ngNotesSession"></textarea>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- En caso de paciente, sección para seleccionar experto -->
                <div nz-row nzGutter="16" *ngIf="userType === 'patient' && stepSection>= 5" [class.disabled-container]="stepSection >
                  currentStepSection && currentStepSection <5" @fadeInAnimation>
                    <div class="title-section-form" nz-col nzSpan="24">
                      <p class="title text-subtitle-bold-upper">EXPERTO</p>
                      <div nz-row nzGutter="16" class="cards-container">
                        <div nz-col *ngIf="!expertSelected">
                          <button
                            class="btn-default"
                            (click)="openSelectExpertModal()"
                            nz-button nzType="default">SELECCIONAR EXPERTO
                          </button>
                        </div>
                        <div class="mb-sm" nz-col [nzXs]="24" [nzSm]="24" [nzMd]="12" [nzLg]="12" [nzXl]="8" [nzXXl]="6" *ngIf="expertSelected" nz-popover=""
                          nzPopoverTitle="" [nzPopoverContent]="'Clic para cambiar experto'" (click)="openSelectExpertModal()">
                          <app-card-expert active="true" [expert]="expertSelected"></app-card-expert>
                        </div>
                      </div>
                      <div nz-row *ngIf="expertSelected" style="margin-top: -1rem;">
                        <div class="mb-sm">
                          <button
                            class="btn-default"
                            (click)="openSelectExpertModal()"
                            nz-button nzType="default">CAMBIAR EXPERTO
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="container-dates" *ngIf="stepSection>= 6" @fadeInAnimation [class.disabled-container]="stepSection > currentStepSection
                    && currentStepSection <6">
                      <div class="title-section-form">
                        <p class="title text-subtitle-bold-upper">FECHA DE LA CITA</p>
                        <div class="default-dates tw-pb-1.5">
                          <app-card-date-appointment *ngFor="let block of itemsCardAppointment; index as i" class="block-date-{{i}}" [value]="block"
                            [active]="itemDateSelected
                            === block.id" (click)="onSelectDate(block)"></app-card-date-appointment>
                        </div>
                        <div nz-row nzGutter="16" style="margin-top: 15px;">
                          <div nz-col nzXs="24" nzSm="12" nzLg="6" class="mb-sm" *ngIf="itemDateSelected === 'other'" @fadeInAnimation>
                            <p class="input-label-form">Fecha</p>
                            <nz-date-picker [required]="true" [(ngModel)]="initDate" [nzFormat]="this.platformConfig.FORMAT.DATE.DDMMYYYY" #ngInitDate="ngModel" name="ngInitDate"
                              nzPlaceHolder="Selecciona la fecha" nzAllowClear="false" (ngModelChange)="onSelectCustomDate($event)"
                              [nzDisabledDate]="utilitiesServices.disabledPastDate"></nz-date-picker>
                          </div>
                          <div nz-col nzXs="24" nzSm="12" nzLg="8" class="mb-sm" *ngIf="itemDateSelected === 'other'" @fadeInAnimation>
                            <p class="input-label-form">Zona horaria</p>
                            <nz-select nzShowSearch [(ngModel)]="timeZone" nzPlaceHolder="Zona horaria" #ngTimeZone="ngModel" name="ngTimeZone"
                              (ngModelChange)="onSelectTimezone($event)">
                              <nz-option *ngFor="let timeZone of this.timeZones;" [nzLabel]="timeZone" [nzValue]="timeZone"></nz-option>
                            </nz-select>
                          </div>
                          <div nz-col nzXs="24" nzSm="10" nzLg="10" class="mb-sm" @fadeInAnimation> <!-- *ngIf="itemDateSelected && itemDateSelected !== 'now'" -->
                            <p class="input-label-form">Duración</p>
                            <div class="durations">
                              <div *ngFor="let duration of durations" class="duration card-container-grey padding-md border-radius-sm"
                                [class.card-container-active]="duration.value === durationSelected" (click)="onSelectDuration(duration)">
                                <p class="text-subtitle-bold">{{ duration.label }}</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div nz-row [nzGutter]="16" class="container-branch" *ngIf="stepSection>= 6 && itemDateSelected" @fadeInAnimation
                      [class.disabled-container]="stepSection > currentStepSection && currentStepSection <6">
                        <div nz-col nzXs="24" nzLg="24" nzXl="24" class="title-section-form availability-section" *ngIf="itemDateSelected && itemDateSelected !== 'now'">
                          <p class="title text-subtitle-bold-upper">DISPONIBILIDAD</p>
                          <div *ngIf="expertSelected && assistants.length> 0 && expertSelected?.timeZone !== assistants[0]?.timeZone">
                            <p class="text-info mb-xlg" @fadeInAnimation *ngIf="!viewTimeZoneExpert && userType === 'patient'">Viendo desde tu zona
                              horaria local, <span class="text-link" (click)="showWithTimeZoneExpert(expertSelected.timeZone)">ver desde la zona
                                horaria del experto</span>.</p>
                            <p class="text-info mb-xlg" @fadeInAnimation *ngIf="viewTimeZoneExpert && userType === 'patient'">Viendo desde la zona
                              horaria del experto, <span class="text-link"
                                (click)="showWithTimeZoneExpert(this.utilitiesServices.getTimeZoneBrowser())">ver desde tu zona horaria local</span>.</p>
                            <p class="text-info mb-xlg" @fadeInAnimation *ngIf="!viewTimeZoneExpert && userType === 'expert'">Viendo desde tu zona
                              horaria local, <span class="text-link" (click)="showWithTimeZoneExpert('patient')">ver desde la zona horaria del
                                paciente</span>.</p>
                            <p class="text-info mb-xlg" @fadeInAnimation *ngIf="viewTimeZoneExpert && userType === 'expert'">Viendo desde la zona
                              horaria del paciente, <span class="text-link"
                                (click)="showWithTimeZoneExpert(this.utilitiesServices.getTimeZoneBrowser())">ver desde tu zona horaria local</span>.</p>
                          </div>
                          <app-date-component
                            [hideIndicatorToday]="true"
                            [date]="selectedDate"
                            [disabledPastDays]="true"
                            (select)="onSelectDayFromDynamicSchedule()"
                            (filterDay)="onSelectDayFromDynamicSchedule()"
                            class="mb-sm"></app-date-component>
                          <div class="disponibility tw-w-full" nz-row [nzGutter]="[20, 20]">
                            <div nz-col nzXs="12" nzSm="8" nzMd="6" nzLg="4" nzXXl="3" *ngFor="let spot of (scheduleAvailability$ | async)?.spots;
                              index as i">
                              <div class="block block-hour-{{i}} card-container-grey padding-md border-radius-sm" (click)="onSelectHour(spot)"
                                [class.card-container-active]="spotSelected === spot.startSystem" [class.disabled-spot]="!spot.available">
                                <p class="text-subtitle-bold">{{ (spot | getDateFromSystem) | date:'HH:mm a' }}</p>
                              </div>
                            </div>
                            <p *ngIf="(scheduleAvailability$ | async)?.spots?.length === 0" class="text-info ml-xs tw-w-full">No hay horarios
                              disponibles</p>
                          </div>
                        </div>
                        <nz-divider style="height: 20px; top: 15px;" nzType="horizontal"></nz-divider>
                        <div nz-col nzXs="24" nzLg="24" nzXl="24" class="title-section-form">
                          <p class="title text-subtitle-bold-upper">CONFIRMACIÓN</p>
                          <ng-container *ngIf="itemDateSelected && itemDateSelected !== 'now'">
                            <P class="text-regular-black">Cita <span>{{ consultationTypeSelected === 'presential' ? 'presencial ' : 'en línea ' }}</span>
                            </P> <!-- <span class="text-info-bold" *ngIf="assistantsExtra">({{assistantsExtra.length + 1 }} {{(assistantsExtra.length + 1) === 1 ? 'participante' : 'participantes'}})</span> -->
                            <p *ngIf="hourSelected" class="text-regular-black" style="margin-top: 5px;">Para <span style="text-decoration: underline;">{{
                                (!isToday ? ' el ' + (this.selectedDate | date:'fullDate') : 'Hoy') }} de {{ hourSelected | date:'h:mm a' }} - {{
                                hourSelectedEnd | date:'h:mm a' }} </span></p> <!-- viernes 15 de Julio de 09:00 AM a 10:00 AM -->
                            <P class="text-regular-black" style="margin-top: 5px;" *ngIf="userType === 'patient' && expertSelected">Experto: <span
                                class="text-info-bold">{{ expertSelected?.name }} {{ expertSelected.lastname }}</span></P>
                            <P class="text-regular-black" style="margin-top: 10px;" *ngIf="consultationTypeSelected === 'presential' && branchOffice">Sucursal:
                              <span class="text-info-bold">{{ branchOffice?.name }}</span></P>
                            <p *ngIf="consultationTypeSelected === 'online' && userType === 'expert'" style="margin-top: 10px;">
                              <span class="text-regular-black">URL reunión: <a [href]="urlSession.url" target="_blank">{{ urlSession.url }}</a></span>
                            </p>
                            <button *ngIf="false" [disabled]="stepSection <7 || currentStepSection <7" (click)="onCloseModal(true)" nz-button
                              nzType="default" class="btn-default mt-sm"><i nz-icon nzType="book" nzTheme="outline"></i>Nueva cita</button>
                          </ng-container>
                          <ng-container *ngIf="itemDateSelected === 'now'">
                            <p class="text-regular-black">Cita <span>{{ consultationTypeSelected === 'presential' ? 'presencial ' : 'en línea ' }}</span>
                            </p>
                            <p class="text-regular-black" style="margin-top: 5px;">Para <span style="text-decoration: underline;">ahora mismo </span></p> <!-- viernes 15 de Julio de 09:00 AM a 10:00 AM -->
                          </ng-container>

                        </div>
                      </div>
                    </form>
                    <nz-divider></nz-divider>
                  </div>
                </ng-template>

                <ng-template #modalFooter>
                  <div class="container-footer-modal" [@fadeInAnimation]>
                    <button
                      style="margin-right: 5px;"
                      (click)="onCloseModal(false)"
                      nz-button nzType="cancel">
                      <i nz-icon nzType="close-circle" nzTheme="outline"></i>
                      CANCELAR</button>
                    <button
                      class="btn-save-appointment"
                      (click)="onCloseModal(true)"
                      [disabled]="!appTourService.tourMode && (stepSection <8 || currentStepSection <8)"
                      nz-button nzType="primary">
                      <i nz-icon nzType="save" nzTheme="outline"></i>
                      {{ itemDateSelected && itemDateSelected !== 'now' ? 'GUARDAR NUEVA CITA' : 'INICIAR CITA' }}</button>
                  </div>
                </ng-template>
              </nz-modal>

              <app-modal-add-patient-appointment
                [isVisibleModal]="isVisibleAddPatientsModal"
                [clinicId]="clinicId"
                [patientId]="(patient$ | async)?._id"
                (closeModal)="closeAddAssistantModal($event)"></app-modal-add-patient-appointment>

              <app-modal-add-expert-appointment
                [isVisibleModal]="isVisibleSelectExpertModal"
                [clinicId]="clinicId"
                [clinicBranchId]="this.branchOffice?._id"
                (closeModal)="closeSelectExpertModal($event)"></app-modal-add-expert-appointment>
